import { Grid, Typography } from "@mui/material";
import { selectAccount, selectClaimInfo } from "../../redux/UserSlice";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { styled } from '@mui/material/styles';
import { useAppSelector } from "../../redux/hooks";
import { getScreenSize } from "../../utils/getScreenSize";
import theme, { dark_blue } from "../../theme";



const typography_style = {
  color: dark_blue,
  textAlign: 'left'
};





export function UserCardInfo() {

  const claimInfo = useAppSelector(selectClaimInfo);
  const account = useAppSelector(selectAccount);
  const theme = useTheme();

  const width = window.screen.width;
  const size = getScreenSize(width);
  return (
    <Grid container >
      <Grid item xs={12} sm={7} >
        <Typography variant='h3' sx={{
          ...typography_style, [theme.breakpoints.up("xl")]: {
            fontSize: '3em',
          }, [theme.breakpoints.up("lg")]: {
            fontSize: '2em',
          },
          [theme.breakpoints.up("sm")]: {
            fontSize: '2em',
          },
        }}>
          {claimInfo?.FIRST_NAME} {claimInfo?.LAST_NAME}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={7}>
        <Typography sx={typography_style}>
          Registration Number: {claimInfo?.REG_NUMBER} <br/>  <br/>
        </Typography>
      </Grid>
     
      <Grid item xs={12}>
        <Typography sx={typography_style}>
        <MailOutlineIcon sx={{ marginRight: "10px" }} fontSize="small"/>
          {claimInfo?.ADDRESS}  {claimInfo?.CITY}
          {claimInfo?.STATE_CODE} {claimInfo?.ZIP}, {claimInfo?.COUNTRY_CODE}<br />
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography sx={typography_style} display='block'>
          <AlternateEmailOutlinedIcon sx={{ marginRight: "10px" }} fontSize="small"/>
          {claimInfo?.EMAIL}
        </Typography>
      </Grid>

      {
        (claimInfo?.CELL_PHONE || claimInfo?.HOME_PHONE) &&
        (<Grid item xs={12}>
          <Typography sx={typography_style} display='block'>
            <PhoneOutlinedIcon sx={{ marginRight: "10px" }} fontSize="small" />
            {claimInfo?.HOME_PHONE ? claimInfo?.HOME_PHONE : (claimInfo?.CELL_PHONE ? claimInfo?.CELL_PHONE : '')}

          </Typography>
          {(claimInfo?.HOME_PHONE && claimInfo?.CELL_PHONE) ?
            <Grid item xs={12}>

              <Typography sx={typography_style} display='block'>
      <PhoneOutlinedIcon sx={{ marginRight: "10px" }} fontSize="small"/>
                {claimInfo?.CELL_PHONE}

              </Typography>
            </Grid> : ''}
        </Grid>)
      }


    </Grid>
  );
}
